import {BlueshiftAPIConnectorError, restfulApiClient} from "./api.ts";
import {type AxiosResponse} from "axios";
import {persistentStorage} from "../build_constants.ts";
import {et} from "../locales/i18n.tsx";

const apiVersion = 1;

/* as AxiosResponse<{
            membership: {
                signedUser: {
                    signed: boolean
                }
            }
        }>*/

/**
 * @namespace membership
 * @property {Object} signedUser
 * @property {String} signedUser.id
 * @property {Date} signedUser.signed 로그인 일시
 * @property {Date} signedUser.expiration_date 만료일
 * @property {Date} signedUser.use_start_date 사용 시작일
 */
export const membership = {
    signedUser: null,

    /**
     * 로그인
     * 로그인 성공시 아무런 예외가 없음
     *
     * 로그인 성공후 반드시 react의 api를 이동하여 페이지 전환 처리 할것
     * ```js
     * const navigate = useNavigate();
     * ....
     * navigate('/about');
     * ```
     * @param id
     * @param password
     */
    async signIn(id: string, password: string) {
        try {
            const response = await restfulApiClient.post("user/login", apiVersion, {
                username: id,
                password: password,
            }) as AxiosResponse<LoginInfo>;
            const data = response!.data;

            persistentStorage["user_id"] = data["X-Session-User-Id"];
            persistentStorage["csrf"] = data["X-Session-CSRF"];
            persistentStorage["session_id"] = data["X-Session-Id"];
        } catch (err) {
            if (err instanceof BlueshiftAPIConnectorError) {
                throw new UserAPIConnectorError(err);
            }
            throw err;
        }
    },

    async modify(current_password: string, new_password: string, new_password_confirm: string) {
        const data = {
            'old_password': current_password,
            'new_password': new_password,
            'confirm_password': new_password_confirm
        }
        try {
            return await restfulApiClient.patch('user', apiVersion, data);
        } catch (err) {
            if (err instanceof BlueshiftAPIConnectorError) {
                throw new UserAPIConnectorError(err);
            }
            throw err;
        }
    },

    /**
     * 로그아웃
     */
    removeSessionStorage() {
        persistentStorage.removeItem("user_id");
        persistentStorage.removeItem("csrf");
        persistentStorage.removeItem("session_id");
    },

    async logout() {
        try {
            await restfulApiClient.delete("user/logout", apiVersion);
            membership.removeSessionStorage()
        } catch (err) {
            membership.removeSessionStorage()
            console.error(err);
        }
    },
    get user_id(): string {
        return persistentStorage["user_id"];
    },
    get session_id(): string {
        return persistentStorage["session_id"];
    },

    /**
     * 계정 초기화 요청.
     * @param {String} email
     */
    async reset(email: string) {
        return await restfulApiClient.patch(`user/${email}/reset`, 1, {});
    }
}

// region Membership API Connector 에서 사용되는 타입 정의
export class UserAPIConnectorError extends BlueshiftAPIConnectorError {
    public readonly localization;


    constructor(err: BlueshiftAPIConnectorError) {
        super(err.cause, err.message);
        this.localization = et(err.cause);
    }
}

interface LoginInfo {
    "X-Session-Id": string,
    "X-Session-CSRF": string,
    "X-Session-User-Id": string,
    "signed": string,
    "expire": string,
    "user": {
        "id": string,
        "expiration_date": string,
        "email": string,
        "use_start_date": string,
    }
}

// endregion  Membership API Connector 에서 사용되는 타입 정의